export default [
  {
    service: 'getUserInfo',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/user',
    method: 'get',
    responseType: 'json',
  },
];
